import React, { useEffect, useState } from "react";
// フォームコンポーネント
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  Button,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import SendIcon from "@material-ui/icons/Send";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import ReactJson from "react-json-view";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    height: "600px",
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    display: "flex",
  },
}));

const columns = [
  { id: "name", minWidth: 60, type: "text" },
  { id: "email", minWidth: 170, type: "text" },
  { id: "id", minWidth: 170, type: "text" },
  { id: "userId", minWidth: 170, type: "text" },
  { id: "shopId", minWidth: 170, type: "text" },
];

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export function UserShop(props) {
  const classes = useStyles();
  const handleUpdateGraphql = props.handleUpdateGraphql;
  const handleDeleteGraphql = props.handleDeleteGraphql;
  const userShops = props.userShops;
  // console.log(userShops);

  return (
    <React.StrictMode>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell key={column.id}>{column.id}</StyledTableCell>
              ))}
              <StyledTableCell key="shopName">ショップ名</StyledTableCell>
              <StyledTableCell key="delete">削除</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {userShops.map((item) => {
              return (
                <StyledTableRow key={item["id"]}>
                  {columns.map((col) => (
                    <StyledTableCell
                      key={col.id}
                      style={{ minWidth: col.minWidth }}
                    >
                      <form
                        onSubmit={(values) => {
                          handleUpdateGraphql("updateUserShop", values);
                        }}
                      >
                        <TextField
                          name={item["id"]}
                          type={col["type"]}
                          label={col["id"]}
                          defaultValue={item[col["id"]]}
                        />
                        {col["id"] !== "name" && col["id"] !== "email" ? (
                          <IconButton color="secondary" type="submit">
                            <SendIcon />
                          </IconButton>
                        ) : null}
                      </form>
                    </StyledTableCell>
                  ))}
                  <StyledTableCell key="shopName">
                    {item.shop.name}
                  </StyledTableCell>
                  <StyledTableCell key="delete">
                    <IconButton
                      color="secondary"
                      onClick={() =>
                        handleDeleteGraphql("deleteUserShop", item["id"])
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.StrictMode>
  );
}

// ■■■■■■■■■■■■■■■■■■
// create
// ■■■■■■■■■■■■■■■■■■
export function UserShopCreate(props) {
  const classes = useStyles();
  const handleCreateGraphql = props.handleCreateGraphql;
  const allShops = props.allShops;
  const userInfos = props.userInfos;
  const userShops = props.userShops;
  const [specificUserShops, setSpecificUserShops] = useState([]);
  const [submitMessage, setSubmitMessage] = useState({});

  const formik = useFormik({
    initialValues: {
      userId: "",
      shopId: "",
    },
    onSubmit: (values) => {
      setSubmitMessage(values);
      handleCreateGraphql("createUserShop", values);
    },
    validationSchema: Yup.object().shape({
      userId: Yup.string().required("userIdは必須です。"),
      shopId: Yup.string().required("shopIdは必須です。"),
    }),
  });

  useEffect(() => {
    var value = formik.values.userId;
    if (value) {
      setSpecificUserShops(userShops.filter((item) => item.userId === value));
    }
  }, [formik.values.userId]);

  return (
    <React.StrictMode>
      <Container>
        <Typography variant="h4" align="center">
          ユーザーショップ登録
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <FormControl className={classes.formControl}>
            <InputLabel>ユーザーID</InputLabel>
            <Select name="userId" {...formik.getFieldProps("userId")}>
              {userInfos.map((e) => (
                <MenuItem value={e.id} key={e.id}>
                  {e.email}
                </MenuItem>
              ))}
            </Select>
            {formik.touched.userId && formik.errors.userId ? (
              <Typography variant="caption" color="error">
                {formik.errors.userId}
              </Typography>
            ) : null}
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel>ショップID</InputLabel>
            <Select name="shopId" {...formik.getFieldProps("shopId")}>
              {allShops.map((e) => (
                <MenuItem value={e.id} key={e.id}>
                  {e.name}
                </MenuItem>
              ))}
            </Select>
            {formik.touched.shopId && formik.errors.shopId ? (
              <Typography variant="caption" color="error">
                {formik.errors.shopId}
              </Typography>
            ) : null}
          </FormControl>

          <Button
            className={classes.button}
            variant="contained"
            type="submit"
            disabled={!formik.isValid}
          >
            登録
          </Button>
          {formik.isSubmitting ? (
            <Typography variant="caption" color="error">
              登録しました：{JSON.stringify(submitMessage)}
            </Typography>
          ) : null}
        </form>
        <ReactJson
          src={specificUserShops}
          theme="twilight"
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          collapseStringsAfterLength={100}
        />
      </Container>
    </React.StrictMode>
  );
}
